document.addEventListener('DOMContentLoaded', () => {
    const tabsBlock = document.querySelector('.tabs-block');
    if (!tabsBlock) return;

    const tabsList = tabsBlock.querySelector('.tabs-block__list');
    const url = new URL(window.location.href);
    const urlID = url.searchParams.get('id');

    tabsBlock.querySelectorAll('.tabs-block__tab').forEach((tab, index) => {
        // Get the id of the tab
        const tabId = tab.getAttribute('data-title');

        // Append the id to the tab list as <li> element
        const tabItem = document.createElement('li');
        tabItem.setAttribute('data-id', tab.getAttribute('data-id'));
        tabItem.innerHTML = `<a href="#${tabId}">${tabId}</a>`;
        tabsList.appendChild(tabItem);

        // Hide all tabs initially
        tab.classList.add('is-hidden');
    });

    // Set active tab based on URL ID or default to first tab
    if (urlID) {
        const activeTabItem = tabsList.querySelector(`li[data-id="${urlID}"]`);
        const activeTab = tabsBlock.querySelector(`.tabs-block__tab[data-id="${urlID}"]`);
        if (activeTabItem && activeTab) {
            activeTabItem.classList.add('is-active');
            activeTab.classList.remove('is-hidden');
        }
    } else {
        // Make first tab active if no URL ID
        const firstTabItem = tabsList.querySelector('li');
        const firstTab = tabsBlock.querySelector('.tabs-block__tab');
        if (firstTabItem && firstTab) {
            firstTabItem.classList.add('is-active');
            firstTab.classList.remove('is-hidden');
        }
    }

    // Add click events to all tabs
    tabsList.querySelectorAll('li').forEach(tabItem => {
        tabItem.addEventListener('click', (e) => {
            e.preventDefault();

            // Update URL with tab ID
            const url = new URL(window.location.href);
            url.searchParams.set('id', tabItem.getAttribute('data-id'));
            window.history.pushState({}, '', url);

            // Remove active class from all tabs
            tabsBlock.querySelectorAll('.tabs-block__list li').forEach((item) => {
                item.classList.remove('is-active');
            });

            // Add active class to clicked tab
            tabItem.classList.add('is-active');

            // Hide all tabs
            tabsBlock.querySelectorAll('.tabs-block__tab').forEach((tab) => {
                tab.classList.add('is-hidden');
            });

            // Show the clicked tab
            const tabId = tabItem.querySelector('a').textContent;
            tabsBlock.querySelector(`.tabs-block__tab[data-title="${tabId}"]`).classList.remove('is-hidden');
        });
    });
});